/* unplugin-vue-components disabled */import { render } from "./MusicListItem.vue?vue&type=template&id=2bf7303c"
import script from "./MusicListItem.vue?vue&type=script&lang=js"
export * from "./MusicListItem.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__